import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';
import { AppConstants } from '@apps/app.constants';
import { SatisfactionApi } from './models/satisfaction-api';

@Injectable({
    providedIn: 'root'
})
export class SatisfactionsMiscApiService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlSurv;
        this.segmentApi = '/surv/satisfactions';
    }

    getUserEntitySatisfactions (): Observable<SatisfactionApi[]>
    {
        return this.get('');
    }

    getAllSatisfactions (): Observable<SatisfactionApi[]>
    {
        return this.get('/all');
    }
}
